import Form from "../../Components/Form"
import TextInput from "../../Components/Form/TextInput";
import React, { useState } from "react";
import Text from "../../Components/Text";
import Workspace from "../../APIController/Workspace";

const WorkspaceCreation = () => {
    const [name, setName] = useState("")
    const { createWorkspace } = Workspace()

    const handleCreateWorkspace = async (e) => {
        e.preventDefault();
        const createResponse = await createWorkspace({ name })
        if (createResponse.ok) {
            window.location.reload();
        }
    }

    return (
        <div className="flex flex-col text-center">
            <Form onSubmitAction={handleCreateWorkspace} submitButtonText={"Erstelle einen neuen Workspace"}>
                <Text type="maintitle">Lass dich zu einem Workspace einladen</Text>
                <Text type="maintitle">oder</Text>
                <Text type="maintitle">Erstelle deinen eigenen Workspace</Text>
                <TextInput attribute={name} id={"name"} placeholder={"Workspace Name"} action={(e) => setName(e.target.value)} />
            </Form>
        </div>
    )
}

export default WorkspaceCreation